import React from "react";
import { getStatusColor, getEnrollmentType } from "./helpers";

const DashboardStats = ({ submissions }) => (
    <div className="dashboard-stats">
        <div className="stat-card">
            <h3>Total Applications</h3>
            <p className="stat-number">{submissions.length}</p>
        </div>
        <div className="stat-card">
            <h3>Complete Applications</h3>
            <p className="stat-number">{submissions.filter((s) => getStatusColor(s) === "completed").length}</p>
        </div>
        <div className="stat-card">
            <h3>Pending Applications</h3>
            <p className="stat-number">{submissions.filter((s) => getStatusColor(s) === "pending").length}</p>
        </div>
        <div className="stat-card">
            <h3>Incomplete Applications</h3>
            <p className="stat-number">{submissions.filter((s) => getStatusColor(s) === "incomplete").length}</p>
        </div>
        <div className="stat-card">
            <h3>Paper Enrollments</h3>
            <p className="stat-number">{submissions.filter((s) => getEnrollmentType(s) === "paper").length}</p>
        </div>
    </div>
);

export default DashboardStats;
